import styled, {css} from "styled-components"
import {spacingCss, SpacingProps} from "../global/css"

interface PicProps extends SpacingProps {
  size?: number | string,
  color?: string,
  border?: boolean,
  marginRight?: boolean
}

const responsiveStyles = css`
  width: 30px;
  height: 30px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 50px;
    height: 50px;
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 100px;
    height: 100px;
  `}
`

export const Pic = styled.div<PicProps>`
  ${({size}) => !size && responsiveStyles}

  ${({size}) => size && css`
    width: ${typeof size === "string" ? size : `${size}px`};
    height: ${typeof size === "string" ? size : `${size}px`};
  `}
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  color: ${({theme}) => theme.colors.fontColor};
  ${({color}) => color && `background-color: ${color};`}
  ${({theme, border}) => border && `border: 2px solid ${theme.colors.greys.white};`}
  ${spacingCss}
`

interface ImgProps {
  size?: number,
  deactivated?: boolean,
  border?: boolean,
  marginRight?: boolean
}
export const Img = styled.img<ImgProps>`
  ${({size}) => !size && responsiveStyles}

  ${({size}) => size && css`
    width: ${typeof size === "string" ? size : `${size}px`};
    height: ${typeof size === "string" ? size : `${size}px`};
  `}
  ${({deactivated}) => deactivated && "filter: grayscale(100%);"}
  ${({theme, border}) => border && `
    border: 2px solid ${theme.colors.greys.white};
    border-radius: 100%;
  `}
  ${({theme, marginRight}) => marginRight && `margin-right: ${theme.spacing.one};`}
`
